// extracted by mini-css-extract-plugin
export var compactFilters = "_dz-4";
export var detailImage = "_dz-1";
export var dropdownContainer = "_dz-2";
export var imageContainer = "_dz-0";
export var selectedCard = "_dz-3";